import React, { useContext } from "react";
import styled from "styled-components";
import cx from "classnames";
import { ContextStore } from "Reducer";
import { List } from "immutable";
import media from "cssMix/index";
import useMediaQuery from "useHooks/useMediaQuery";

const PayoutRankBarWrapper = styled.div`
  width: 100%;
  height: 110px;
  box-sizing: border-box;
  margin-bottom: 66px;
  display: flex;
  justify-content: space-between;
  overflow-x: overlay;
  flex-shrink: 0;
  & > div:not(:last-child) {
    margin-right: 20px;
  }
  ${media.tablet`
  position:absolute;
  width:calc(100% - 32px);
  top:-50px;
  height: auto;
  margin-bottom: 0;
  padding:12px 0;
  overflow-x: overlay;
  margin-top:12px;
  `}
`;

const PayoutRankBarItemWrapper = styled.div`
  width: 270px;
  height: 100px;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 1px;
  background: rgba(249, 190, 0, 0.37);
  cursor: pointer;
  flex-shrink: 0;
  &.top-three {
    background: linear-gradient(160deg, rgb(84, 41, 175), rgb(27, 91, 150));
  }
  .rank-item {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    background: linear-gradient(110deg, rgb(19 17 51), rgb(32 18 75));
    border-radius: 8px;
    padding: 23px 16px;
    display: flex;
    align-items: center;
    & > img {
      width: 54px;
      margin-right: 16px;
      ${media.tablet`
        width:44px;
      `}
    }
  }
  .rank-medal {
    color: #fff;
    position: relative;
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    margin-right: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    font-weight: bold;
    &:before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: ${(props) =>
        props.rank < 4
          ? `url("images/medal_top.png") no-repeat`
          : `url("images/medal_default.png") no-repeat`};
      background-size: 100% auto;
      background-position: center 2px;
    }
    ${media.tablet`
    width: 30px;
    height: 30px;
    font-size:12px;
    `}
  }
  .rate {
    font-size: 15px;
    font-weight: 600;
    color: ${(props) =>
      props.rtpExp === 0 ? "#fff" : props.rtpExp >= 0 ? "#50c577" : "#d02a43"};
    display: flex;
    align-items: center;
    & .arrow {
      font-size: 12px;
      transform: scale(0.8);
      margin-left: 5px;
    }
    & .bx-minus {
      font-size: 15px;
      margin-left: 5px;
      font-weight: bolder;
    }
  }
  .rank-info {
    width: 50%;
    & p {
      margin: 0;
    }
    & .game-name {
      font-size: 16px;
      font-weight: 500;
      color: #fff;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      ${media.tablet`
        font-size:14px;
        white-space: break-spaces;
      `}
    }
  }
  ${media.tablet`
  width:260px;
  height:60px;
  `}
`;
const PayoutRankBar = ({ payoutRankTop5, dispatch }) => {
  const itemClickHandler = () => {
    dispatch({
      type: "CHANGE_DATA",
      path: "mainAreaRoute",
      value: "PayoutRank",
    });
  };
  return (
    <PayoutRankBarWrapper>
      {payoutRankTop5.map((v, k) => (
        <PayoutRankBarItem
          game={v}
          rank={k + 1}
          key={k}
          itemClickHandler={itemClickHandler}
        />
      ))}
    </PayoutRankBarWrapper>
  );
};

const PayoutRankBarItem = ({ game, itemClickHandler, rank }) => {
  const {
    state: { stateReducer },
  } = useContext(ContextStore);
  const gameList = stateReducer.get("gameList", List());
  const gameDetail = gameList.filter(
    (v) => v.get("game_id") === game.get("gameCode")
  );
  const lang = stateReducer.get("lang");
  const historyRtpExp = game.get("historyRTPExp");
  const latestRtpExp = historyRtpExp
    .sort((a, b) => b.get("unixTimestamp") - a.get("unixTimestamp"))
    .get(0);
  const rtpExp = latestRtpExp.get("rtpExp");
  const { mediaType } = useMediaQuery();

  return (
    <PayoutRankBarItemWrapper
      className={cx({ "top-three": rank < 4 })}
      rank={rank}
      rtpExp={rtpExp}
      onClick={itemClickHandler}
    >
      <div className="rank-item">
        <div className="rank-medal">{rank}</div>
        <img alt="" src={gameDetail.getIn([0, "icon", lang])} />
        <div className="rank-info">
          <p className="game-name">{gameDetail.getIn([0, "name", lang])}</p>
          {mediaType === "pc" && (
            <div className="rate">
              <p>{rtpExp}</p>
              {rtpExp === 0 ? (
                <span>
                  <i className="bx bx-minus"></i>
                </span>
              ) : rtpExp >= 0 ? (
                <i className="bx bxs-up-arrow arrow"></i>
              ) : (
                <i className="bx bxs-down-arrow arrow"></i>
              )}
            </div>
          )}
        </div>
        {mediaType !== "pc" && (
          <div className="rate">
            <p>{rtpExp}</p>
            {rtpExp === 0 ? (
              <span>
                <i className="bx bx-minus"></i>
              </span>
            ) : rtpExp >= 0 ? (
              <i className="bx bxs-up-arrow arrow"></i>
            ) : (
              <i className="bx bxs-down-arrow arrow"></i>
            )}
          </div>
        )}
      </div>
    </PayoutRankBarItemWrapper>
  );
};
export default PayoutRankBar;
